// «Insertar en la respuesta del caso» desde la base de conocimiento: cada cuadro de respuesta abierto (ui/Respuesta)
// se anota aqui con la direccion de su pantalla. Si hay uno abierto, el texto entra directo; si se cerro pero la persona
// venia de un caso, se guarda pendiente y se vuelve al caso (el cuadro lo toma al abrirse); si no, se copia.
// Mismo nombre que EVENTO_USAR_RESPUESTA de ui/Respuesta (aqui sin importarlo para no crear un ciclo).
const EVENTO_USAR_RESPUESTA = 'consola:usar-respuesta';

let abiertas = 0;
let ultimoLugar: string | null = null;
const CLAVE = 'consola.insertarPendiente';

export function registrarRespuesta(lugar = `${location.pathname}${location.search}`) {
  abiertas++;
  ultimoLugar = lugar;
  return () => {
    abiertas = Math.max(0, abiertas - 1);
  };
}

export const hayRespuestaAbierta = () => abiertas > 0;
export const lugarDeRespuesta = () => ultimoLugar;

export type DetalleUsar = string | { texto: string; aviso: string };

export function dejarPendiente(texto: string) {
  try {
    sessionStorage.setItem(CLAVE, JSON.stringify({ texto, hasta: Date.now() + 5 * 60_000 }));
  } catch {
    /* sin almacenamiento: no queda pendiente */
  }
}

export function tomarPendiente(): string | null {
  try {
    const v = sessionStorage.getItem(CLAVE);
    if (!v) return null;
    sessionStorage.removeItem(CLAVE);
    const j = JSON.parse(v) as { texto?: string; hasta?: number };
    return j.texto && (j.hasta ?? 0) > Date.now() ? j.texto : null;
  } catch {
    return null;
  }
}

export const AVISO_ARTICULO = 'El artículo quedó en la respuesta. Revísalo antes de enviar.';

export type Resultado = 'insertado' | 'pendiente' | 'copiado' | 'fallo';

// Inserta `texto` donde se pueda. `ir` navega (para volver al caso).
export async function insertarEnRespuesta(texto: string, ir: (lugar: string) => void): Promise<Resultado> {
  if (hayRespuestaAbierta()) {
    window.dispatchEvent(new CustomEvent<DetalleUsar>(EVENTO_USAR_RESPUESTA, { detail: { texto, aviso: AVISO_ARTICULO } }));
    return 'insertado';
  }
  const lugar = lugarDeRespuesta();
  if (lugar && /^\/bandeja\/(casos|correos)/.test(lugar)) {
    dejarPendiente(texto);
    ir(lugar);
    return 'pendiente';
  }
  try {
    await navigator.clipboard.writeText(texto);
    return 'copiado';
  } catch {
    return 'fallo';
  }
}
